import * as _4 from 'lodash4';

interface IAPSclOptions {
  created_ts: string;
  id: number;
  is_active: boolean;
  order: number;
  title: string;
  updated_ts: string;
  value: string;
}

export class APSclOptionsItem {
  id: number;
  name: string;
  options: IAPSclOptions[];

  constructor(apSclOptionsItem: Partial<APSclOptionsItem>) {
    _4.merge(this, apSclOptionsItem);
  }

  static build(apSclOptionsItem: Partial<APSclOptionsItem>): APSclOptionsItem {
    return new APSclOptionsItem(apSclOptionsItem);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/builders/ap_scl_options_item_builder.ts